export const GET_ENHANCED_AUTH_BENEFITS = "@@ENHANCED_AUTH/GET_ENHANCED_AUTH_BENEFITS" as const;

export const getEnhancedAuthBenefits = (payload) =>
  ({
    type: GET_ENHANCED_AUTH_BENEFITS,
    payload,
  } as const);

export type GetEnhancedAuthBenefitsAction = ReturnType<typeof getEnhancedAuthBenefits>;
